import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
  Input,
  Flex,
  useDisclosure,
  Tooltip,
  IconButton,
  Button,
  Checkbox,
  useToast,
  Select,
  Spacer,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  IHealthPlanMappingItem,
  IHealthPlanType,
  IUnmappedHealthPlanNameItem,
} from '../Infrastructure/Interfaces';
import TablePagination from '../TablePagination/TablePagination';
import useTable from '../TablePagination/UseTable';
import { AppDispatch } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import { FaMapSigns } from 'react-icons/fa';
import { UnmappedHealthPlansMappingModalPopup } from './UnmappedHealthPlansMappingModalPopup';
import { BsPencilSquare } from 'react-icons/bs';
import HealthPlanMappingModalPoupup from '../HealthPlanPayerMapping/HealthPlanMappingModalPopup';
import { setHealthPlanMappingItem } from '../Store/HealthPlanMappingReducer';

interface Props {
  unmappedHealthPlanList: IUnmappedHealthPlanNameItem[];
}

function UnmappedHealthPlanPg({ unmappedHealthPlanList }: Props) {
  const [value, setValue] = useState('');
  const [TableFilter, setTableFilter] = useState(unmappedHealthPlanList);
  const [currentPage, setCurrentPage] = useState(1);
  const [claimsPerPage, setClaimsPerPage] = useState<number>(10);
  const lastIndex = currentPage * claimsPerPage;
  const firstIndex = lastIndex - claimsPerPage;
  const { slice, range } = useTable(
    value.length > 0 ? TableFilter : unmappedHealthPlanList,
    currentPage,
    claimsPerPage
  );
  const dispatch = useDispatch<AppDispatch>();
  const [checkedHealthPlanNames, setcheckedHealthPlanNames] = useState<
    {
      healthPlanName: string;
      healthPlanType: string;
    }[]
  >([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedHealthPlans, SetSelectedHealthPlans] = useState<
    IHealthPlanMappingItem[]
  >([]);
  const {
    isOpen: isOpenUnmappedModal,
    onOpen: onOpenUnmappedModal,
    onClose: onCloseUnmappedModal,
  } = useDisclosure();

  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userrole =
    userdetails[0].userRole != '' ? userdetails[0].userRole : 'User';
  var healthplanlist: IHealthPlanType[] = useSelector((state: any) => {
    return state.healthPlanTypeList.healthPlanTypeList;
  });
  const toast = useToast();

  useEffect(() => {
    setcheckedHealthPlanNames([]);
  }, [unmappedHealthPlanList]);

  const filterData = (e: any) => {
    if (e.target.value !== '') {
      setValue(e.target.value);
      const filterTable = unmappedHealthPlanList.filter(o =>
        Object.keys(o).some(k =>
          String(o[k as keyof IUnmappedHealthPlanNameItem])
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        )
      );
      setTableFilter([...filterTable]);
    } else {
      setValue(e.target.value);
    }
  };

  const onCheckboxSelect = (unmappedItem: IUnmappedHealthPlanNameItem) => {
    const itemsCopy = Array.from(checkedHealthPlanNames);

    var index = checkedHealthPlanNames.findIndex(
      v => v.healthPlanName == unmappedItem.healthPlanName
    );
    var plantypeindex = checkedHealthPlanNames.findIndex(
      v => v.healthPlanType == unmappedItem.planType
    );

    var plantypedata: IHealthPlanType = healthplanlist.find(
      item => item.healthPlanType == unmappedItem.planType
    )!;
    //var payerindex = checkedHealthPlanNames.findIndex(v => v.payerAddressId == mappedItem.payerAddressId);

    if (index === -1) {
      if (checkedHealthPlanNames.length === 0 || plantypeindex > -1) {
        setcheckedHealthPlanNames(checkedHealthPlanNames =>
          checkedHealthPlanNames.concat({
            healthPlanName: unmappedItem.healthPlanName,
            healthPlanType: unmappedItem.planType,
          })
        );
        SetSelectedHealthPlans([
          ...selectedHealthPlans,
          {
            healthPlanMappingId: 0,
            healthPlanMasterId: 0,
            healthPlanName: unmappedItem.healthPlanName,
            displayName: '',
            healthPlanType: plantypedata?.healthPlanType!,
            healthPlanTypeId: plantypedata?.healthPlanTypeId!,
            payerAddressId: 0,
            payerName: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            phoneNo: '',
            faxNo: '',
            region: unmappedItem.region,
            scenarioId: 0,
            scenarioName: '',
            deliverOption: '',
            isActive: false,
            createdBy: '',
            createdOn: '',
            modifiedBy: '',
            modifiedOn: '',
            faxToFaxNumber: '',
            healthPlanId: unmappedItem.insurancePlan,
          },
        ]);
      } else {
        toast({
          title: 'Warning!',
          description:
            'Please select health plans mapped to ' +
            checkedHealthPlanNames[0].healthPlanType +
            ' only.',
          position: 'top',
          status: 'warning',
          duration: 4000,
          isClosable: true,
        });
      }
    } else {
      itemsCopy.splice(index, 1);
      setcheckedHealthPlanNames(itemsCopy);
      SetSelectedHealthPlans(
        selectedHealthPlans.filter(
          x => x.healthPlanName !== unmappedItem.healthPlanName
        )
      );
    }
  };

  useEffect(() => {
    setcheckedHealthPlanNames([]);
    SetSelectedHealthPlans([]);
  }, [unmappedHealthPlanList]);

  function openModal(unmappeditem: IUnmappedHealthPlanNameItem) {
    var data: IHealthPlanType = healthplanlist.find(
      item => item.healthPlanType == unmappeditem.planType
    )!;

    const item: IHealthPlanMappingItem = {
      healthPlanMappingId: 0,
      healthPlanMasterId: 0,
      payerAddressId: 0,
      payerName: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      phoneNo: '',
      faxNo: '',
      displayName: '',
      isActive: true,
      healthPlanTypeId: data?.healthPlanTypeId!,
      healthPlanType: '',
      healthPlanName: unmappeditem.healthPlanName,
      region: unmappeditem.region,
      createdBy: '',
      createdOn: '',
      modifiedBy: '',
      modifiedOn: '',
      scenarioId: 0,
      scenarioName: '',
      deliverOption: '',
      faxToFaxNumber: '',
      healthPlanId: unmappeditem.insurancePlan,
    };
    dispatch(setHealthPlanMappingItem(item));
    onOpen();
  }

  return (
    <>
      <Box display=" flex" flexDirection="column">
        <Flex display="flex" justifyContent="flex-end" paddingBottom=".5rem">
          {userrole.toUpperCase() != 'USER' ? (
            <Button
              mr="1rem"
              bg="#002677"
              color="white"
              variant="outline"
              size="md"
              leftIcon={<FaMapSigns />}
              onClick={onOpenUnmappedModal}
              isDisabled={checkedHealthPlanNames.length < 1 ? true : false}
            >
              Map Health Plan
            </Button>
          ) : (
            ''
          )}
          <Input
            htmlSize={24}
            width="auto"
            className="form-control"
            type="text"
            placeholder="Search..."
            onChange={filterData}
            style={{ float: 'right', marginRight: '0.5rem' }}
          />
        </Flex>
        <TableContainer borderRadius="5px" borderTopColor="black">
          <Table
            variant="striped"
            colorScheme="blackAlpha"
            size="sm"
            overflow="Auto"
          >
            <Thead bgColor="#002677">
              <Tr>
                <Th color="white" width={1}></Th>
                <Th color="white">HEALTH PLAN NAME</Th>
                <Th color="white">HEALTH PLAN ID</Th>
                <Th color="white">REGION</Th>
                <Th color="white">PLAN TYPE</Th>
                {userrole.toUpperCase() != 'USER' && (
                  <Th color="white">
                    ACTIONS
                  </Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {(value.length > 0 ? TableFilter : unmappedHealthPlanList)
                .slice(firstIndex, lastIndex)
                .map((item, index) => {
                  return (
                    <Tr
                      key={index + '_' + item.healthPlanName}
                      style={{ fontSize: '14px' }}
                    >
                      <Td>
                        <Checkbox
                          isChecked={
                            checkedHealthPlanNames.findIndex(
                              x => x.healthPlanName == item.healthPlanName
                            ) === -1
                              ? false
                              : true
                          }
                          onChange={() => onCheckboxSelect(item)}
                          border="black"
                        ></Checkbox>
                      </Td>
                      <Td whiteSpace="pre">{item.healthPlanName}</Td>
                      <Td whiteSpace="pre">{item.insurancePlan}</Td>
                      <Td>{item.region}</Td>
                      <Td>{item.planType}</Td>
                      {userrole.toUpperCase() != 'USER' && (
                        <Td pt="0" pb="0" mt="0" mb="0" pr="30px">
                          <Tooltip
                            hasArrow
                            label="Map Health Plan"
                            placement="left"
                          >
                            <IconButton
                              size="xs"
                              aria-label="edit"
                              icon={<BsPencilSquare />}
                              onClick={e => openModal(item)}
                            />
                          </Tooltip>
                        </Td>
                      )}
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <Flex display="flex" flexDirection="row">
            <Flex />
            <Spacer />
            <TablePagination
              range={range}
              slice={slice}
              setPage={setCurrentPage}
              page={currentPage}
            />
            <Spacer />
            <Select
              onChange={e => setClaimsPerPage(parseInt(e.target.value))}
              width="100px"
              height="30px"
              mt="5px"
              mr="5px"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex>
        </TableContainer>
      </Box>
      <UnmappedHealthPlansMappingModalPopup
        isOpen={isOpenUnmappedModal}
        onOpen={onOpenUnmappedModal}
        onClose={onCloseUnmappedModal}
        healthitems={selectedHealthPlans}
      />
      <HealthPlanMappingModalPoupup
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
    </>
  );
}

export default UnmappedHealthPlanPg;
